function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEngaged(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11.441,
    viewBox: "0 0 12 11.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28626",
    d: "M24.829 20.869c-.482-.448-.972-.133-1.407.3-2.2 2.195-1.993 1.937-2.177 1.812.181-.047 2.911-2.741 2.915-2.744a.857.857 0 0 0 .3-1.035.832.832 0 0 0-1.393-.194s-2.693 2.581-2.705 2.584v-.005a.386.386 0 0 1-.1-.2l3.185-2.991a.875.875 0 0 0 .286-.953.777.777 0 0 0-1.3-.293q-.982.944-1.968 1.884l-1.44 1.378c-.073.058-.105-.02-.153-.045l-.009-.114c.077-.081.152-.165.232-.243.877-.848 1.758-1.692 2.632-2.544a.759.759 0 0 0-1.061-1.084q-.693.649-1.38 1.3c-.005 0-3.321 3.184-3.61 3.4-.056.041-.088.157-.19.088s-.078-.151-.056-.249a8.3 8.3 0 0 0 .706-3.01.875.875 0 0 0-.463-.773.7.7 0 0 0-1.068.538 6.437 6.437 0 0 1-.227 1.359c-.233.877-1.13 2.173-1.263 3.843a4.57 4.57 0 0 0 1.661 3.974 3.9 3.9 0 0 0 2.862.731 4.91 4.91 0 0 0 2.587-1.189c.24-.205 4.573-4.32 4.578-4.324a.785.785 0 0 0 .026-1.201z",
    transform: "translate(-13.09 -16.177)",
    style: {
      fill: "#fffefe"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngaged);
export default __webpack_public_path__ + "static/media/engaged.3baa308c.svg";
export { ForwardRef as ReactComponent };